import { Box } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useEffect, useState } from 'react'

import LoadingOverlay from 'components/Shared/LoadingOverlay'
import { useAppSelector } from 'redux/Hook'
import { useToolBuilder } from 'containers/ToolBuilder/Hook'

const IframeLoader = ({ livePreviewWidth }: { livePreviewWidth: string }) => {
  const { t } = useTranslation()
  const { toolUrl } = useToolBuilder()
  const [iframeLoadStatus, setIframeLoadStatus] = useState(true)

  const { fetching, saving } = useAppSelector((state) => state.toolBuilder)

  const [reloadKey, setReloadKey] = useState(0)

  useEffect(() => {
    if (saving) {
      setReloadKey((prev) => prev + 1)
      setIframeLoadStatus(true)
    }
  }, [saving])

  return (
    <Box width={livePreviewWidth} px={livePreviewWidth === '100%' ? 6 : 0}>
      <LoadingOverlay loading={iframeLoadStatus || fetching || saving}>
        <Box
          key={reloadKey}
          component="iframe"
          frameBorder={0}
          marginWidth={0}
          marginHeight={0}
          scrolling="auto"
          width="100%"
          src={toolUrl}
          onLoadStart={() => setIframeLoadStatus(true)}
          onLoad={() => setIframeLoadStatus(false)}
          style={{ height: 'calc(-220px + 100vh)' }}
          title={`${t('toolBuilder.toolBuilderPreview')}`}
        />
      </LoadingOverlay>
    </Box>
  )
}

export default IframeLoader
